import TYPES from '@/types';

// Application
import CustomerOverviewService from '@/modules/home-dashboard/customer-overview/application/services/customer-overview-service';

// Domain
import CustomerOverviewState from '@/modules/home-dashboard/customer-overview/domain/state/customer-overview-state';
import Inject from '@/modules/shared/domain/di/inject';
import { Router } from '@/modules/shared/domain/router';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';

export default class FlagshipDefineGoalsCardViewModel {
  @Inject(TYPES.CUSTOMER_OVERVIEW_SERVICE)
  private readonly customer_overview_service!: CustomerOverviewService;

  @Inject(TYPES.ROUTER)
  private readonly router!: Router;

  @Inject(TYPES.I18N)
  readonly translator!: Translator;

  readonly i18n_namespace = 'components.my-investment-dashboard.flagship-define-goals.flagship_define_goals_card';

  customer_overview: CustomerOverviewState = this.customer_overview_service.get_customer_overview();

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  goToGoalsDashboard = () => {
    if (!this.customer_overview.item.has_any_product_contracted) {
      const recommended_investment_product = this.customer_overview.item
        .investor_profile_overview.recommended_investment_product?.name;
      window.location.href = `/goals-dashboard?recommended_investment_product=${recommended_investment_product}`;
    } else {
      window.location.href = '/goals-dashboard?create_goals=true';
    }
  }
}
